module.exports = __webpack_public_path__ + "img/sankaku_98_red.c53cdb9d.png";